/**
 * Requires a module only if available.
 * @memberof util
 * @param {string} moduleName Module to require
 * @returns {?Object} Required module if available and not empty, otherwise `null`
 */
module.exports = function inquire(moduleName) {
  try {
    if (typeof require !== 'function') {
      return null;
    }
    // eslint-disable-next-line import/no-dynamic-require, global-require
    const mod = require(moduleName);
    if (mod && (mod.length || Object.keys(mod).length)) return mod;
    return null;
  } catch (err) {
    // ignore
    return null;
  }
};
